"use client";
import { Avatar } from "@mui/material";

const PALETTE = [
  "#0C4A6E","#155E75","#1D4ED8","#7C3AED","#9333EA",
  "#B45309","#0E7490","#166534","#9A3412","#6B21A8",
];

function hashToIndex(str, mod = PALETTE.length) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return Math.abs(h) % mod;
}

function getInitials(input) {
  if (!input) return "NA";
  const cleaned = String(input).trim();
  if (!cleaned) return "NA";
  // email -> use username part; else use words
  const parts = cleaned.includes("@")
    ? cleaned.split("@")[0].split(/[.\-_+]/).filter(Boolean)
    : cleaned.split(/\s+/).filter(Boolean);

  const first = parts[0]?.[0] ?? "";
  const second = parts[1]?.[0] ?? (cleaned.includes("@") ? cleaned.split("@")[0]?.[1] ?? "" : "");
  return (first + second).toUpperCase().slice(0, 2);
}

export default function SmartAvatar({ src, name, email, size = 40 }) {
  const seed = (name || email || "NA").toLowerCase();
  const color = PALETTE[hashToIndex(seed)];
  const initials = getInitials(name || email || "");
  const alt = name || email || "User";
  console.log(src,"src")
  return (
    <Avatar
      alt={alt}
      src={src || undefined}
      sx={{
        width: "40px",
  height: "40px",
  backgroundColor:" #1648CE",
  color: "white",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "bold",
  fontSize: "18px",
      }}
    >
      {!src ? initials : null}
    </Avatar>
  );
}
